import * as React from 'react';
import { UsersList } from './UsersList';
import { EditUserForm } from './EditUserForm';
import { Routes, Route, useParams, useNavigate } from 'react-router-dom';
import { NotFound } from '../NotFound';
import { RoleSection } from '../../components/RoleSection';
import { NotAllowed } from '../NotAllowed';
import { AppSection } from '../../components/AppSection';

function EditUserRoute() {
    const params = useParams();
    const navigate = useNavigate();
    return (<EditUserForm history={{ push: (to: string) => navigate(to) }} username={params.username} />);
}

export class Users extends React.Component<any,any>{

    public render(){
        return (<React.Fragment>
            <AppSection section="users" />
            <RoleSection role="admin" render={(forbidden)=>(
                <Routes>
                    {forbidden && <Route path="*" element={<NotAllowed />} />}
                    <Route path="create" element={<EditUserRoute />} />
                    <Route path="edit/:username" element={<EditUserRoute />} />
                    <Route path="" element={<UsersList />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            )} />
        </React.Fragment>)
    }
}
